.button-sort {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: var(--palette-foreground-secondary);
  cursor: pointer;
  display: flex;
  font: use-font-secondary("700 14px/16px");
  margin-left: auto;
  padding: 0;

  &:focus {
    outline: 1px solid var(--palette-foreground-primary);
    outline-offset: 2px;
  }

  &__icon {
    height: 16px;
    width: 16px;

    &[data-sort="ascending"] {
      transform: rotate(180deg);
    }
  }
}
